import React from "react";
import LeadGeneartionList from "../LeadGenerationList";

const ClientLeadList = () => {
  return (
    <>
      <LeadGeneartionList
        userType={"CLIENT"}
        url={"/client-lead-generation/"}
      />
    </>
  );
};

export default ClientLeadList;
